export enum EAccountFeature {
  pdfSignatures = 'pdfSignatures',
  timeline = 'timeline',
  aalSitePlan = 'aalSitePlan',
  aalExport = 'aalExport',
  YCO_PDF_LAYOUT = 'pdfYcoLayout',
  FLEET_MANAGEMENT = 'fleetManagement',
}
